var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9742 5.41763C10.8617 4.6145 10.239 4 9.48771 4H9.4862C8.65615 4.00097 7.984 4.75257 7.98486 5.67873C7.99197 12.235 7.99142 15.0122 7.9832 15.0103C6.60515 15.0103 5.56185 12.0567 3.75285 12.0567C1.9438 12.0567 1.64025 13.1299 2.36312 14.0797C2.84504 14.7128 7.9832 22 7.9832 22H15.9998C18.209 22 19.9998 20.2092 19.9998 18.0001L20 8.6788C20 7.75163 19.3264 7 18.4954 7H18.4939C17.6639 7.00097 16.9917 7.75257 16.9926 8.67873L16.9909 13.0103M10.9742 5.41763C10.9861 5.50274 10.9923 5.58996 10.9923 5.6788M10.9742 5.41763L10.9728 13.0103M10.9742 5.41763L10.9745 3.67873C10.9736 2.75257 11.6458 2.00097 12.4758 2H12.4773C13.3083 2 13.9819 2.75163 13.9819 3.6788L13.9835 5.67838M13.9835 5.67838V13.0103M13.9835 5.67838C13.9829 4.75238 14.6549 4.00097 15.4849 4H15.4864C16.3173 4 16.9909 4.75163 16.9909 5.6788V8.6788",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand1);
export default __webpack_public_path__ + "static/media/hand1.e8a59a6f3653caf064a8c93e91f6b6d6.svg";
export { ForwardRef as ReactComponent };